import {AdaptiveTabs} from '@gravity-ui/components';

import withDatalensSpecific from './withDatalensSpecific';

export default withDatalensSpecific(AdaptiveTabs);
